import React, { useEffect, useState } from 'react'

import moment, { Moment } from 'moment'

import Spinner from '../../App/Components/Spinner/Spinner'
import CompareDateRangeSelection from '../CompareDateRangeSelection/CompareDateRangeSelection'

import { Client } from './Client/Client'
import { AppointmentCharts } from './Components/AppointmentCharts/AppointmentCharts'
import { IAppointmentsReport } from './interface/IAppointmentsReport'
import DateRangeSelection from '../DateRangeSelection/DateRangeSelection'

export const AppointmentsReport = () => {
    const [isLoading, setIsLoading] = useState<boolean>(false)

    const [from1, setFrom1] = useState<Moment>(moment().startOf('isoWeek'))
    const [to1, setTo1] = useState<Moment>(moment().endOf('isoWeek'))

    const [span, setSpan] = useState<'week' | 'month' | 'year'>('week')
    const [appointmentReport, setAppointmentReport] = useState<
        IAppointmentsReport[] | null
    >()

    useEffect(() => {
        const fetchData = async () => {
            const getAppointmentReport = await Client.getAppointmentsReport(
                from1,
                to1,
                span
            )
            setAppointmentReport(getAppointmentReport)
        }
        fetchData().then((error) => console.log(error))
    }, [from1, to1])

    return (
        <div>
            <CompareDateRangeSelection
                isDisplayCompare={false}
                onSelected={(newSpan, range1) => {
                    setSpan(newSpan)
                    setFrom1(range1.from)
                    setTo1(range1.to)
                }}
                from={from1}
                to={to1}
                availableSpans={['week', 'month', 'year']}
            />

            {isLoading || null === from1 ? (
                <Spinner />
            ) : (
                <div>
                    <p>{from1.format('YYYY-MM-DD')}</p>
                    <AppointmentCharts
                        appointmentReport={appointmentReport}
                    />
                </div>
            )}
        </div>
    )
}
